// extracted by mini-css-extract-plugin
export var arrows = "_2h-5";
export var decrementer = "_2h-9";
export var disabled = "_2h-3";
export var error = "_2h-1";
export var hiddenText = "_2h-a";
export var incrementer = "_2h-8";
export var input = "_2h-7";
export var inputWrapper = "_2h-0";
export var leadingIcon = "_2h-b";
export var readonly = "_2h-2";
export var regular = "_2h-6";
export var small = "_2h-4";